import React, { useState, useEffect, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "../common/helpers/formatDate";
import Calendar from 'admin/common/icons/sidebar/Calendar';

export const NewDateRange = (props) => {
    const { setDatefilter } = props
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState(new Date());
    const datePickerRef = useRef(null);
    const changedate = (update) => {
        if (update[1] === null) {
            const startOfDay = update[0]
                ? new Date(update[0].setHours(12, 10, 10, 999))
                : null;
            setStartDate(startOfDay);
            setEndDate(update[1])
            setDatefilter([startOfDay, new Date()]);
        } else {
            const startOfDay = update[0]
                ? new Date(update[0].setHours(12, 10, 10, 999))
                : null;
            const endOfDay = update[1]
                ? new Date(update[1].setHours(23, 59, 59, 999))
                : null;
            setStartDate(startOfDay);
            setEndDate(endOfDay)
            setDatefilter([startOfDay, endOfDay]);
        }



    }
    useEffect(() => {
        const prevMonth = new Date();
        prevMonth.setMonth(prevMonth.getMonth() - 1);
        setStartDate(prevMonth);
        setDatefilter([prevMonth, endDate]);
        // eslint-disable-next-line
    }, []);
    return (
        <React.Fragment>
            <div className="dateranger position-relative" >
                <div className=" main-body-top-status-bar-multi-date-picker-wrap " onClick={() => datePickerRef.current.setOpen(true)}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.5 13.0601V13M9.4375 13.0601V13M9.4375 9.8V9.73984M12.9375 9.8V9.73984M2.875 6.59998H15.125M4.45833 2V3.20014M13.375 2V3.19999M13.375 3.19999H4.625C3.17525 3.19999 2 4.2745 2 5.59998V13.6C2 14.9255 3.17525 16 4.625 16H13.375C14.8247 16 16 14.9255 16 13.6L16 5.59998C16 4.2745 14.8247 3.19999 13.375 3.19999Z" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <input type="text" value={startDate ? formatDate(startDate) : "DD/MM/YYYY"} readOnly />
                    <span className="date-arrow">
                        -
                    </span>
                    <input type="text" value={endDate ? formatDate(endDate) : formatDate(new Date())} readOnly />
                    <span className="main-body-top-status-bar-multi-date-picker-wrap-calender">


                    </span>
                </div>
                <DatePicker
                    selectsRange={true}
                    monthsShown={2}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                        changedate(update);
                    }}
                    dateFormat="yyyy-MM-dd"
                    ref={datePickerRef}
                    className='d-flex'
                    showMonthDropdown="true"
                    showYearDropdown="true"
                    popperPlacement='auto'
                    autoComplete='none'
                />
            </div>
        </React.Fragment>
    );
}

export const DateRangeNew = (props) => {
    const { setDatefilter } = props
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState(new Date());
    const datePickerRef = useRef(null);
    const changedate = (update) => {
        if (update[1] === null) {
            const startOfDay = update[0]
                ? new Date(update[0].setHours(12, 10, 10, 999))
                : null;
            setStartDate(startOfDay);
            setEndDate(update[1])
            setDatefilter([startOfDay, new Date()]);
        } else {
            const startOfDay = update[0]
                ? new Date(update[0].setHours(12, 10, 10, 999))
                : null;
            const endOfDay = update[1]
                ? new Date(update[1].setHours(23, 59, 59, 999))
                : null;
            setStartDate(startOfDay);
            setEndDate(endOfDay)
            setDatefilter([startOfDay, endOfDay]);
        }



    }
    useEffect(() => {
        const prevMonth = new Date();
        prevMonth.setMonth(prevMonth.getMonth() - 1);
        setStartDate(prevMonth);
        setDatefilter([prevMonth, endDate]);
        // eslint-disable-next-line
    }, []);
    return (
        <React.Fragment>
            <div className="dateranger new position-relative Date-Range-New" >
                <div className=" main-body-top-status-bar-multi-date-picker-wrap new" onClick={() => datePickerRef.current.setOpen(true)}>
                    <Calendar color="#A4A4A4" width="15px" height="15px" />
                    <input type="text" value={startDate ? formatDate(startDate) : "DD/MM/YYYY"} readOnly />
                    |
                    <Calendar color="#A4A4A4" width="15px" height="15px" />
                    <input type="text" value={endDate ? formatDate(endDate) : formatDate(new Date())} readOnly />

                </div>
                <DatePicker
                    selectsRange={true}
                    monthsShown={1}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                        changedate(update);
                    }}
                    dateFormat="yyyy-MM-dd"
                    ref={datePickerRef}
                    className='d-flex'
                    showMonthDropdown="true"
                    showYearDropdown="true"
                    popperPlacement='auto'
                    autoComplete='none'

                />
            </div>
        </React.Fragment>
    );
}
// export default DateRange;